import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserState {
  isUser: boolean;
  isLogin: boolean;
  isRegister: boolean;
  isForgetPassword: boolean;
  isRecoveryPassword: boolean;
  isUserStatus: boolean;
  userStatus: string;
  isMessage: boolean;
  isMessageStatus: boolean;
  isOtp: boolean;
  otpSession: string;
  errorMessage: string;
  isChangePassword: boolean;
  operationType: "register" | "forgetPassword" | null;
  messageType: "register" | "changePassword" | null;
  otpType: "sms" | "mail" | "";
  referralCode: string;
}

const initialState: UserState = {
  isLogin: true,
  isUser: false,
  isRegister: false,
  isForgetPassword: false,
  isRecoveryPassword: false,
  isUserStatus: false,
  userStatus: "",
  isMessage: false,
  isMessageStatus: false,
  isOtp: false,
  otpSession: "",
  errorMessage: "",
  isChangePassword: false,
  operationType: null,
  otpType: "",
  messageType: null,
  referralCode: "",
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setIsUser(state, action: PayloadAction<boolean>) {
      state.isUser = action.payload;
    },
    setIsRegister(state, action: PayloadAction<boolean>) {
      state.isRegister = action.payload;
    },
    setIsLogin(state, action: PayloadAction<boolean>) {
      state.isLogin = action.payload;
    },
    setIsForgetPassword(state, action: PayloadAction<boolean>) {
      state.isForgetPassword = action.payload;
    },
    setIsRecoveryPassword(state, action: PayloadAction<boolean>) {
      state.isRecoveryPassword = action.payload;
    },
    setIsUserStatus(state, action: PayloadAction<boolean>) {
      state.isUserStatus = action.payload;
    },
    setUserStatus(state, action: PayloadAction<string>) {
      state.userStatus = action.payload;
    },
    setIsMessage(state, action: PayloadAction<boolean>) {
      state.isMessage = action.payload;
    },
    setIsOtp(state, action: PayloadAction<boolean>) {
      state.isOtp = action.payload;
    },
    setIsMessageStatus(state, action: PayloadAction<boolean>) {
      state.isMessageStatus = action.payload;
    },
    setOtpSession(state, action: PayloadAction<string>) {
      state.otpSession = action.payload;
    },
    setErrorMessage(state, action: PayloadAction<string>) {
      state.errorMessage = action.payload;
    },
    setIsChangePassword(state, action: PayloadAction<boolean>) {
      state.isChangePassword = action.payload;
    },
    setOtpType(state, action: PayloadAction<"sms" | "mail" | "">) {
      state.otpType = action.payload;
    },
    setMessageType(
      state,
      action: PayloadAction<"register" | "changePassword" | null>
    ) {
      state.messageType = action.payload;
    },

    setOperationType(
      state,
      action: PayloadAction<"register" | "forgetPassword" | null>
    ) {
      state.operationType = action.payload;
    },
    setReferralCode(state, action: PayloadAction<string>) {
      state.referralCode = action.payload;
    },
  },
});

export const {
  setIsUser,
  setIsRegister,
  setIsLogin,
  setIsForgetPassword,
  setIsRecoveryPassword,
  setIsUserStatus,
  setUserStatus,
  setIsMessage,
  setIsOtp,
  setIsMessageStatus,
  setOtpSession,
  setErrorMessage,
  setIsChangePassword,
  setOperationType,
  setOtpType,
  setMessageType,
  setReferralCode,
} = userSlice.actions;
export default userSlice.reducer;
